'use client'

import { useSearchParams } from 'next/navigation'
import PaginationRenderer from '@/app/[locale]/_components/Pagination/PaginationRenderer'
import type { PaginationProps } from '@/app/[locale]/_components/Pagination/types'

export function ClientSidePagination({ pagination, ...props }: PaginationProps) {
	const params = useSearchParams()

	// biome-ignore lint/correctness/noUnusedVariables: pageParam is destructured to exclude from paramsObject
	const { page: pageParam, ...paramsObject } = Object.fromEntries(params.entries())

	return <PaginationRenderer {...props} paramsObject={paramsObject} pagination={pagination} />
}
